import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const NAMED_HTML_ENTITIES: Record<string, string> = {
  amp: "&", lt: "<", gt: ">", quot: '"', apos: "'", nbsp: " ",
  ndash: "–", mdash: "—", hellip: "…", bull: "•", middot: "·",
  lsquo: "‘", rsquo: "’", sbquo: "‚", ldquo: "“", rdquo: "”", bdquo: "„",
  laquo: "«", raquo: "»", lsaquo: "‹", rsaquo: "›",
  copy: "©", reg: "®", trade: "™", deg: "°", sect: "§", para: "¶",
  times: "×", divide: "÷", plusmn: "±", minus: "−",
  frac14: "¼", frac12: "½", frac34: "¾",
  euro: "€", pound: "£", yen: "¥", cent: "¢", curren: "¤",
};

/**
 * Decodes HTML entities ("&amp;", "&#8217;", "&#x20AC;", "&ndash;") without the DOM, so it
 * works in the SSR build and returns the same string on the server and in the browser,
 * which hydration requires. Unknown named entities are left as they are.
 */
export function decodeHtmlEntities(text: string): string {
  if (!text) return text;

  return text.replace(/&(#\d+|#x[\da-f]+|[a-z][a-z\d]*);/gi, (entity, body: string) => {
    if (body[0] === "#") {
      const code = body[1] === "x" || body[1] === "X"
        ? parseInt(body.slice(2), 16)
        : parseInt(body.slice(1), 10);
      return code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : entity;
    }
    return NAMED_HTML_ENTITIES[body] ?? entity;
  });
}
